/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RegistrationMode = {
    Online: 'Online',
    RegistrationManager: 'RegistrationManager',
    TrialEnrollment: 'TrialEnrollment'
} as const;
export type RegistrationMode = typeof RegistrationMode[keyof typeof RegistrationMode];


export function instanceOfRegistrationMode(value: any): boolean {
    for (const key in RegistrationMode) {
        if (Object.prototype.hasOwnProperty.call(RegistrationMode, key)) {
            if (RegistrationMode[key as keyof typeof RegistrationMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RegistrationModeFromJSON(json: any): RegistrationMode {
    return RegistrationModeFromJSONTyped(json, false);
}

export function RegistrationModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationMode {
    return json as RegistrationMode;
}

export function RegistrationModeToJSON(value?: RegistrationMode | null): any {
    return value as any;
}

export function RegistrationModeToJSONTyped(value: any, ignoreDiscriminator: boolean): RegistrationMode {
    return value as RegistrationMode;
}

